import { action } from 'satcheljs';
import type { OwaDate } from 'owa-datetime';
import type { DisposalType } from 'owa-graph-schema';

export interface EMPTY_FOLDER_STORE_UPDATEActionMessage {
    folderId: string;
    clientLastSyncTime: OwaDate | null;
    deletedItemsFolderId: string;
    disposalType: DisposalType;
    deleteSubFolders: boolean;
    rowKeysToExclude: string[] | undefined;
}
const defaultExport: (
    folderId: string,
    clientLastSyncTime: OwaDate | null,
    deletedItemsFolderId: string,
    disposalType: DisposalType,
    deleteSubFolders: boolean,
    rowKeysToExclude?: string[]
) => EMPTY_FOLDER_STORE_UPDATEActionMessage = action(
    'EMPTY_FOLDER_STORE_UPDATE',
    (
        folderId: string,
        clientLastSyncTime: OwaDate | null,
        deletedItemsFolderId: string,
        disposalType: DisposalType,
        deleteSubFolders: boolean,
        rowKeysToExclude?: string[]
    ): EMPTY_FOLDER_STORE_UPDATEActionMessage => ({
        folderId,
        clientLastSyncTime,
        deletedItemsFolderId,
        disposalType,
        deleteSubFolders,
        rowKeysToExclude,
    })
);
export default defaultExport;
